var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSegmentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 22.3346V10.668H0.166016L12.9993 0.167969L25.8327 10.668H22.3327V11.8346H19.9993V8.8888L12.9993 3.17214L5.99935 8.8888V20.0013H8.33268V22.3346H3.66602ZM15.566 24.668L10.666 19.768L12.2993 18.1346L15.566 21.4013L22.4493 14.518L24.0827 16.1513L15.566 24.668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSegmentation);
export default __webpack_public_path__ + "static/media/icon_segmentation.b6e0fe24605fea8e8d634b4225d56d15.svg";
export { ForwardRef as ReactComponent };